import { AwesomeEvent, ComponentAPI, Value } from '@philips-emr/tws-core';
import { RenderEventListener } from '@philips-emr/tws-core/lib/component/types';
import { isValidWidth } from '@philips-emr/tws-utils';

export default class HpmsDynamicContentFieldApi extends ComponentAPI<{ data: Record<string, Value>, visible: boolean, width: number }>{

  /** @event */
  @AwesomeEvent
  onDynamicContentRender = new RenderEventListener();

  getData(): Record<string, Value> {
    return this.state.data;
  }

  isVisible(): boolean {
    return this.state.visible;
  }

  setVisible(visible: boolean): void {
    this.setState({ ...this.state, visible });
  }

  setWidth(width: number): void {
    if (isValidWidth(width)) {
      this.setState({ ...this.state, width });
    }
  }

  getWidth(): number {
    return this.state.width;
  }

}
